<template>
    <modal :name="modalName" transition="fade" top="0" width="700" height="auto" draggable="true"
        @before-open="beforeOpen" :adaptive="true">
        <div class="modal-container">
            <div class="modal-header">
                <h3>Scan Key</h3>
                <button @click=close>X</button>
            </div>
            <div class="modal-content">
                <div class="modal-intro-information">
                </div>
                <Search class="gate-search" v-bind:search="search" search-icon="true"
                    inputStyle="text-align: left; color: black; border-bottom: 2px solid #000;"
                    v-bind:searchCallback="(data) => { this.performSearch(data) }" placeholder="Scan or type Key ID" />
            </div>
            <div class="modal-footer">
                <button @click="scanKey()">Validate Key</button>
            </div>
        </div>
    </modal>
</template>

<script>
import EventBus from "../../eventBus.js";
import * as Constants from "../../js/constants.js";
import Search from "../pages/pageComps/Search.vue";

const NAME = Constants.SCAN_KEY_MODAL

export default {
    modalName: NAME,
    components: {
        Search,
    },
    opened(event) {
        console.log('Opening...', event)
    },
    watch: {
        title(newValue) {
            if (newValue != "") this.$refs['title'].classList.remove('invalid')
        },
        description(newValue) {
            if (newValue != "") this.$refs['description'].classList.remove('invalid')
        },
    },
    data() {
        return {
            modalName: NAME,
            search: "",
            title: "",
        }
    },
    methods: {
        show() {
            this.$modal.show(NAME);
        },
        beforeOpen(event) {
            console.log('Before Opening...', event)
        },
        validateKey() {
            console.log("Validating key...")
        },
        close() {
            this.$modal.hide(NAME);
        },
        performSearch(data) {
            if (data.length > 11) {
                this.fetchKey(data).then(keyData => {
                    EventBus.$emit(Constants.UPDATE_KEY_MODAL_DATA, keyData)
                    this.$modal.hide(NAME)
                    this.$modal.show(Constants.GATE_MODAL)
                }).catch(err => {
                    this.search = ""
                    alert(err)
                })
            }
        },
        fetchKey(keyId) {
            let url = "https://ufgow7hy1f.execute-api.us-east-2.amazonaws.com/dev/nautica2/keys/" + keyId
            return new Promise((resolve, reject) => {
                fetch(
                    url,
                    {
                        method: `GET`,
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                        },
                    }
                )
                    .then((res) => res.json())
                    .then((data) => {
                        if(data.data.length == 0) {
                            reject("Key Not Found")
                        }
                        resolve(data.data[0]);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        scanKey() {
            if (this.search.length > 11) {
                this.performSearch(this.search)
            } else {
                alert("Please enter a valid Key ID")
            }
        }
    },
    created() {
        console.log("In modal")
        console.log("Create Scan Key Modal Params", this.$$props)
    },
}
</script>

<style scoped>
.modal-container {
    display: flex;
    flex-direction: column;
    background-color: #699991;
    color: white;
    border-radius: 4px;
}

.modal-create-data-item input {
    flex: 1;
    height: 100%;
    width: 100%;
    font-size: 14px;
    outline: 0;
    border: 0;
    text-align: center;
}

.visitor-modal-title::placeholder {
    color: black;
}

.validate-button {
    color: white;
    background-color: #87BAB7;
    width: 60%;
    margin-left: auto;
    margin-right: auto;
    height: 2rem;
    border-radius: 5px;
    margin-top: .5rem;
    margin-bottom: .5rem;
}

.modal-field {
    padding: 1rem;
    font-size: 25px;
    border-bottom: 1px solid #87BAB7;
}

.modal-time-info {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
}

.modal-time-inner {
    display: flex;
    flex-direction: column;
    padding: 1rem;
    border-right: 1px solid #87BAB7;
    border-left: 1px solid #87BAB7;
}

.helper-text {
    text-align: left;
    font-size: 15px;
}

.circle {
    width: 160px;
    height: 160px;
    line-height: 160px;
    border-radius: 50%;
    font-size: 50px;
    color: #fff;
    text-align: center;
    background: #87BAB7;
}

.resident-search-bar {
    display: flex;
    width: 100%;
    height: 100%;
    font-size: 12px !important;
    background-color: #F3F3F3;
    align-items: center;
    border-radius: 0px;
    border: 0;
}

.resident-search-bar::placeholder {
    color: black;
}

.resident-search-bar input {
    background-color: white;
    text-align: center;
}

.modal-header {
    padding: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: white;
    border-radius: 4px;
    color: black;
    border: 1px solid black;
}

.modal-header h3 {
    font-size: 36px;
}

.modal-content {
    padding: 2rem;
}

.modal-intro-information {
    display: flex;
    flex-direction: column;
}

.modal-intro-information label {
    color: black;
    text-align: left;
    text-decoration: underline;
}

.modal-violation-title {
    font-size: 24px;
    margin-bottom: 18px;
    border-bottom: 1px solid black;
    text-decoration: none;
    outline: 0;
}

.modal-violation-title::placeholder {
    color: #d9d9d988;
}

.modal-violation-description {
    font-size: 14px;
    font-weight: lighter;
    border-bottom: 1px solid black;
    text-decoration: none;
    outline: 0;
    margin-bottom: 18px;
    resize: none;

}

.modal-violation-description::placeholder {
    color: #d9d9d988;
}

.upload-attachment {}

.upload-attachment button {
    display: flex;
    flex-direction: row;
    padding: 8px;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    background-color: #d9d9d9dd;
    color: black
}

.modal-dropdown-button {
    color: black;
    background-color: #d9d9d9;
    padding: 4px 8px;
    margin-right: 10px;
    border: 1px solid black;
    border-radius: 4px;
}

.modal-create-data {
    margin-top: 41px;
    display: flex;
    flex-direction: column;
}

.modal-create-data-item {
    display: flex;
    flex-direction: row;
    color: black;
    border: 1px solid black;
    height: 36px;
    border-radius: 4px;
}

.modal-create-data-item input {
    flex: 1;
    background-color: #d9d9d9;
    text-align: center;
}

.modal-create-data-item p {
    align-content: center;
    text-align: left;
    font-weight: bold;
    flex: 1;
    padding-left: 8px;
    border-right: 1px solid black;
}

.modal-create-data-item textarea {
    align-content: center;
    text-align: left;
    font-weight: bold;
    flex: 1;
    height: 100%;
    resize: none;
    font-size: 14px;
    font-weight: lighter;
    outline: 0px;
    background-color: #d9d9d9dd;

}

.modal-create-data-item div {
    flex: 1;
    background-color: #d9d9d9;
}

.modal-create-data-item button {
    flex: 1;
    width: 100%;
    height: 100%;
    background-color: #ccd9d9d9;
}

.modal-create-data-item div ul {
    height: 100%;
}

.modal-create-data-item div li {
    position: relative;
    flex: 1;
    list-style: none;
    text-decoration: none;
    background-color: white;
    text-align: center;
    height: 100%;
    align-items: center;
    justify-content: center;
    z-index: 2;
    border-bottom: 1px solid #ccd9d9d9;

}

.modal-create-data-item div li:hover {
    background-color: #699991;
}

.invalid {
    outline: 1px solid red;
}

.modal-footer {
    padding: 1rem;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: space-between;
    background-color: white;
    border-radius: 4px;
    color: black;
    border: 1px solid black;
}

.toggle-container {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.toggle-container p {
    margin-left: 8px;
}

.modal-footer button {
    background-color: #699991;
    padding: 4px 24px;
    border-radius: 4px;
    border: 1px solid black;
    font-weight: bold;

}

input::placeholder {
    color: black;
    opacity: 1;
    /* Ensures full opacity in Firefox */
}
</style>